var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33483 10.3343C7.33483 10.7025 7.6333 11.001 8.0015 11.001C8.36963 11.001 8.66816 10.7025 8.66816 10.3343V8.66764H10.3348C10.703 8.66764 11.0015 8.36918 11.0015 8.00098C11.0015 7.63278 10.703 7.33431 10.3348 7.33431H8.66816V5.66764C8.66816 5.29946 8.36963 5.00098 8.0015 5.00098C7.6333 5.00098 7.33483 5.29946 7.33483 5.66764V7.33431H5.66813C5.29995 7.33431 5.00146 7.63278 5.00146 8.00098C5.00146 8.36918 5.29995 8.66764 5.66813 8.66764H7.33483V10.3343Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00117 14.6676C11.683 14.6676 14.6678 11.6828 14.6678 8.0009C14.6678 4.319 11.683 1.33423 8.00117 1.33423C4.31925 1.33423 1.33447 4.319 1.33447 8.0009C1.33447 11.6828 4.31925 14.6676 8.00117 14.6676ZM8.00117 13.3342C10.9466 13.3342 13.3345 10.9464 13.3345 8.0009C13.3345 5.05538 10.9466 2.66756 8.00117 2.66756C5.05563 2.66756 2.66781 5.05538 2.66781 8.0009C2.66781 10.9464 5.05563 13.3342 8.00117 13.3342Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plusCircle.9c992e720045d64786851f9070ad1b80.svg";
export { ForwardRef as ReactComponent };